import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'totalAmount': 0,
  'realAmount': 0,
};

const last = (list) => list[list.length - 1];

export const amountTotals = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.GET_AMOUNT_TOTALS]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.GET_AMOUNT_TOTALS_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'totalAmount': last(action.response.idealData),
      'realAmount': last(action.response.realAmount),
    }),
    [ActionTypes.GET_AMOUNT_TOTALS_ERROR]: (state) => ({
      ...state,
      'loading': false,
      'totalAmount': 0,
      'realAmount': 0,
    }),
  })(state, action);
};
